import PubSub from "underpub-js";

var CardFour = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-CardFour',
	};

	$.extend(true, this.options, options);

};

CardFour.prototype.init = function() {

	var self = this;

};

export default CardFour;
